let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l9Y1q")).then(() => parcelRequire('aIRk9'));